import { ToastState, SET_TOAST_MSG, ToastActions } from "../types";


const initialState: ToastState = {
  message: undefined,
  variant: 'default'
};


export default function notificationReducer(state = initialState, action: ToastActions): ToastState {
  switch (action.type) {
    case SET_TOAST_MSG:
      return {
        ...state,
        message: action.message,
        variant: action.variant,
      }
    default:
      return state;
  }
}